// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, HostListener, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import * as moment from 'moment';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';

import {ScrollEvent} from 'ngx-scroll-event';
import {FormControl} from "@angular/forms";
import {ConsumerService} from "../../../recursos/servicio/consumer.service";
import {WebServices} from "../../../recursos/modelo/consumerModel/web-services.enum";
import {LogNoTransformados} from "./recursos/modelo/LogNoTransformados";
import {isNullOrUndefined} from "util";
import {LayoutService} from "../../../recursos/servicio/layout.service";

declare var swal: any;
declare const $: any;


@Component({
    moduleId: module.id,
    selector: 'app-logNoTransformados',
    templateUrl: './view/list-logNoTransformados.component.html',
    styleUrls: ['./css/list-logNoTransformados.component.css'],
    providers: [ConsumerService]
})
export class ListLogNoTransformadosComponent implements OnInit, OnChanges {
    // ITEM DEL CRUD
    origenCRUD = "documento";

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    // variables de pantalla
    filtroList: any = {
        search: "",
        document: "-1"

    };
    mensaje = "<i class='material-icons'>search</i>REALICE SU BUSQUEDA UTILIZANDO LOS FILTROS";
    loading = false;
    noHayResultados = false;
    es;
    filtro = false;
    cargandoConsulta = false;
    cargandoList = false;
    documentType: any[] = [];
    searchField: FormControl;
    emisor = "";
    empresaAdministradora = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_LOG_LISTAR: false,
        ROLE_LOG_CONSULTAR: false,
        ROLE_LOG_REGISTRAR: false,
        ROLE_LOG_MODIFICAR: false,
        ROLE_LOG_ELIMINAR: false,
        ROLE_LOG_ACTIVAR: false,
    };
    //variables modelo
    ItemLista: any[];
    ItemSelected: LogNoTransformados;
    rangeDates: Date[];
    logSeleccionado = new LogNoTransformados();
    inicial = true;
    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;
    // scroll list
    scrollItems: LogNoTransformados[] = [];
    readonly bufferSize: number = 50;
    timer: any;
    loadingTexto: boolean = false;
    loadingTextoRefinir: boolean = false;
    totalRegistros = 0;
    tieneCDR: boolean = false;

    private colorTitle = null;

    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private layout: LayoutService,
                private jwtUtil: UtilConfig,
                private _localeService: BsLocaleService) {

        this._localeService.use(this.locale);

        this.documentType = [];
        this.documentType.push({label: 'TODOS', value: "-1"});
        this.documentType.push({label: 'FACTURA', value: "INVOICE"});
        this.documentType.push({label: 'BOLETA', value: "TICKET"});
        this.documentType.push({label: 'NOTA DE CRÉDITO', value: "CREDIT_NOTE"});
        this.documentType.push({label: 'NOTA DE DÉBITO', value: "DEBIT_NOTE"});
        this.documentType.push({label: 'PERCEPCIONES', value: "PERCEPTION"});
        this.documentType.push({label: 'RETENCIONES', value: "RETENTION"});
        this.documentType.push({label: 'GUÍA DE REMISIÓN', value: 'DESPATCH_ADVICE'});
        this.documentType.push({label: 'GUÍA TRANSPORTISTA', value: 'DESPATCH_TRANSPORT'});
        this.documentType.push({label: 'RESUMEN DIARIO', value: "SUMMARY_DOCUMENT"});
        this.documentType.push({label: 'COMUNICACIÓN DE BAJA', value: "RA_VOIDED_DOCUMENT"});
        this.documentType.push({label: 'RESUMEN DE REVERSIONES', value: "RR_VOIDED_DOCUMENT"});

        this.ItemLista = [];

        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'DD/MM/YYYY'
        });

        var fechaIni = (new Date().getMonth() + 1) + "/01/" + new Date().getFullYear();
        this.rangeDates = [new Date(), new Date()];

        this.emisor = jwtUtil.getCurrentUser().customer.id;
        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (this.emisor == jwtUtil.ESCON_CUSTOMER)
            this.empresaAdministradora = true;

        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        if (this.authorities.ROLE_LOG_LISTAR)
            this.route.params.subscribe(params => {
                if (params['busqueda']) {
                    this.filtroList.search = params['busqueda'];
                }

                // RANGO FECHA
                if (params['inicio']) {
                    this.rangeDates[0] = new Date(params['inicio']);
                }
                if (params['fin']) {
                    this.rangeDates[1] = new Date(params['fin']);
                }

                if (params['inicial']) {
                    this.inicial = false;
                }
                this.filtroList.document = params['documentType'] || "-1";
                this.realizarBusqueda();
            });

        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }
    }

    @HostListener('window:keyup.escape', ['$event'])
    keyEvent(event: KeyboardEvent) {
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        $.each(this.ItemLista, function (pos, item) {
            item.seleccionado = false;
        });
    }

    public handleScroll(event: ScrollEvent) {
        if (event.isReachingBottom) {
            this.fetchMore(event);
        }
        if (event.isWindowEvent) {
            this.fetchMore(event);
            console.log(`This event is fired on Window not on an element.`);
        }

    }

    fetchMore(event) {
        if (this.scrollItems.length != this.ItemLista.length) {
            this.loadingTexto = true;
            this.fetchNextChunk(this.scrollItems.length, this.bufferSize, event).then(chunk => {
                this.scrollItems = this.scrollItems.concat(chunk);
                this.loadingTexto = false;
            }, () => this.loadingTexto = false);
        } else {
            this.loadingTexto = false;
            this.loadingTextoRefinir = true;
        }
    }

    fetchNextChunk(skip: number, limit: number, event?: any): Promise<LogNoTransformados[]> {
        return new Promise((resolve, reject) => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (skip < this.ItemLista.length) {
                    return resolve(this.ItemLista.slice(skip, skip + limit));
                }
                reject();
            }, 1000 + Math.random() * 1000);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        this.reset();
    }

    reset() {
        this.fetchNextChunk(0, this.bufferSize, {}).then(chunk => {
            this.scrollItems = chunk;
            this.cargandoList = false;
        });
    }

    ngOnInit() {

        this.searchField = new FormControl();
        this.searchField.valueChanges
            .debounceTime(1000)
            .distinctUntilChanged()
            .subscribe(term => {
                if (!this.inicial) {
                    this.listar();
                }
            });

    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴

    refrescar() {
        this.realizarBusqueda();
    }

    listar() {
        let filtro: any = {};
        if (this.filtroList.search != "")
            filtro.busqueda = this.filtroList.search;

        // RANGO FECHA
        filtro.inicio = moment(this.rangeDates[0]).format("MM/DD/YYYY");
        filtro.fin = moment(this.rangeDates[1]).format("MM/DD/YYYY");

        filtro.inicial = false;

        if (this.filtroList.document)
            filtro.documentType = this.filtroList.document;
        this.router.navigate(['/content', {outlets: {'second': ['logNoTransformados', filtro]}}]);
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘

    cerrarDetalle() {
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        $.each(this.ItemLista, function (pos, log) {
            log.seleccionado = false;
        });
        this.logSeleccionado = new LogNoTransformados();
    };

    consulta(item) {
        this.tieneCDR = false;
        if (item.seleccionado) {
            item.seleccionado = !item.seleccionado;
            $("ul#slide-out").removeClass("open");
            $("i.cerrarAleta").removeClass("open");
            return false;
        }

        $.each(this.ItemLista, function (pos, log) {
            log.seleccionado = false;
        });
        $("ul#slide-out").addClass("open");
        $("i.cerrarAleta").addClass("open");
        item.seleccionado = !item.seleccionado;
        this.logSeleccionado = new LogNoTransformados();
        this.cargandoConsulta = true;
        this.consumer.getById('log', item.id, WebServices.URL_GET_LOG_PSE_FALLIDOS)
            .subscribe(result => {
                this.logSeleccionado = result["log"];
                if (!isNullOrUndefined(this.logSeleccionado.respuesta) && this.logSeleccionado.respuesta.length != 0) {
                    let respuesta: any = this.logSeleccionado.respuesta[0];
                    if ((!isNullOrUndefined(respuesta.responseCode) && respuesta.responseCode != "")) {
                        if (parseInt(respuesta.responseCode) >= 2000) {
                            this.tieneCDR = true;
                        }
                    }
                }
                this.logSeleccionado.fileName = this.logSeleccionado.fileName.replace(".json", "");
                this.logSeleccionado.linkRequest = this.jwtUtil.URL_WS_BACKEND + "/" + WebServices.URL_GET_ARCHIVO_PSE + "?log.id=" + this.logSeleccionado.id + "&tipoDescarga=PSE";
                this.logSeleccionado.linkResponse = this.jwtUtil.URL_WS_BACKEND + "/" + WebServices.URL_GET_ARCHIVO_PSE + "?log.id=" + this.logSeleccionado.id + "&tipoDescarga=CDR";
                this.cargandoConsulta = false;
            }, err => {
                this.cargandoConsulta = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener los documentos.", this.router)
            });
    }

    private realizarBusqueda() {
        // LLAMADO AL SERVICIO
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        this.cargandoList = true;

        let params: any = {
            criterio: this.filtroList.search ? this.filtroList.search : null,
            fechaDesde: this.rangeDates[0],
            fechaHasta: this.rangeDates[1]
        };

        if (this.filtroList.document != "-1")
            params.documentType = this.filtroList.document;

        this.consumer.post(WebServices.URL_LIST_LOG_PSE_FALLIDOS, params)
            .subscribe(result => {
                this.ItemLista = result["logs"];
                if ((this.ItemLista != null) && (this.ItemLista.length == 0)) {
                    this.mensaje = "<i class='material-icons'>youtube_searched_for</i> UTILICE OTRO FILTRO DE BÚSQUEDA SOBRE <b>" + this.origenCRUD.toUpperCase() + "S </b>, NO SE HAN CONSEGUIDO REGISTROS";
                }
                this.totalRegistros = result["rowsCount"];
                if (this.totalRegistros == 0) {
                    this.cargandoList = false;
                } else {
                    this.reset();
                }

            }, err => {
                this.ItemLista = [];
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener los documentos", this.router)
            });
    }

}






// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/logNoTranformados/list-logNoTransformados.component.ts